import { api } from "./api";

// INTEGRITY: if the player has already allowed location for this site (or an app wrapper has), tell the room where the
// device is. It is only used to stop two accounts in the same room from sitting at one table. We never prompt here.
export const shareLocationIfAllowed = async () => {
  if (!navigator.geolocation || !navigator.permissions?.query) return false;
  try {
    const perm = await navigator.permissions.query({ name: "geolocation" });
    if (perm.state !== "granted") return false;
    const pos = await new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject, { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 }));
    await api.post("/api/me/location", {
      lat: pos.coords.latitude, lon: pos.coords.longitude, accuracy_m: Math.round(pos.coords.accuracy || 0),
    });
    return true;
  } catch {
    return false;
  }
};
